// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AuthorAutocompleteController from "./author_autocomplete_controller"
application.register("author-autocomplete", AuthorAutocompleteController)

import BookmarkFeaturedController from "./bookmark_featured_controller"
application.register("bookmark-featured", BookmarkFeaturedController)

import BookmarkVisibilityController from "./bookmark_visibility_controller"
application.register("bookmark-visibility", BookmarkVisibilityController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FrameScrollController from "./frame_scroll_controller"
application.register("frame-scroll", FrameScrollController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import IdleBirdController from "./idle_bird_controller"
application.register("idle-bird", IdleBirdController)

import InfiniteScrollController from "./infinite_scroll_controller"
application.register("infinite-scroll", InfiniteScrollController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import NoteController from "./note_controller"
application.register("note", NoteController)

import NotificationController from "./notification_controller"
application.register("notification", NotificationController)

import PostMediumFavoritedController from "./post_medium_favorited_controller"
application.register("post-medium-favorited", PostMediumFavoritedController)

import PostMediumHiddenController from "./post_medium_hidden_controller"
application.register("post-medium-hidden", PostMediumHiddenController)

import PricingController from "./pricing_controller"
application.register("pricing", PricingController)

import PublicUsernameController from "./public_username_controller"
application.register("public-username", PublicUsernameController)

import ScrollRevealController from "./scroll_reveal_controller"
application.register("scroll-reveal", ScrollRevealController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import TimezoneController from "./timezone_controller"
application.register("timezone", TimezoneController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import UserPickerController from "./user_picker_controller"
application.register("user-picker", UserPickerController)
